<template>
  <div class="booth-container">
    <!-- 抽奖 -->

    <draggableButton
      v-if="vueAppTypeName === ''"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
      @mousedown="onMouseDown"
      @mouseup="onMouseUp"
      @click="handleClick"
    >
      <div @click="gotoLottery">
        <img src="@/assets/img/detail/lottery_icons.png" />
      </div>
    </draggableButton>
    <div class="booth" ref="booth">
      <div class="swiper-wrapper" v-if="wifi == 1" :style="swiperWrapperStyle">
        <van-swipe :autoplay="videoFiles && videoFiles.length > 0 ? -1 : 3000" lazy-render indicator-color="#E7BB8F" class="custom-swipe">
          <van-swipe-item v-if="videoFiles && videoFiles.length > 0" class="video-swipe-item">
            <div class="media-wrapper video-wrapper">
              <video
                ref="videoPlayer"
                :src="videoFiles[0]"
                type="video/mp4"
                controls
                controlslist="nodownload"
                autoplay
                class="video-player"
                playsinline
                webkit-playsinline="true"
                x5-video-player-type="h5"
                x5-playsinline="true"
                preload="auto"
                @loadeddata="handleVideoLoaded"
                @error="handleVideoError"
                style="object-fit: fill"
              ></video>
              <div class="custom-video-controls">
                <div class="fullscreen-button" @click.stop="handleFullScreen">
                  <i class="fullscreen-icon"></i>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item v-for="image in storeArr['backgroundImgs']" :key="image">
            <div class="media-wrapper">
              <img :src="image" class="booth-bannerImg" />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="swiper-wrapper" v-if="wifi == 2" :style="swiperWrapperStyle">
        <van-swipe :autoplay="6000" lazy-render indicator-color="#E7BB8F">
          <van-swipe-item v-for="image in storeArr['backgroundImgs']" :key="image">
            <img :src="image" class="booth-bannerImg" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="content-container" v-touch:swipeup="topSlide" ref="content">
      <div class="info">
        <div class="title">
          <div class="left">
            <div class="booth-title">
              <div class="left">
                <img
                  src="@/assets/img/my/user-logo.png"
                  class="booth-bannerImg"
                  v-if="storeArr.logo == null"
                />
                <img :src="storeArr.logo" alt="" v-else />
                <span>
                  <slot name="title">{{ storeArr.storeName }}</slot>
                </span>
              </div>
              <!-- <ul v-if="vueAppTypeName === ''">
                <li>信誉:</li>
                <li>
                  <slot name="reputation">{{ storeArr.honestyName }}</slot>
                </li>
              </ul> -->
            </div>
          </div>
          <div class="link" style="margin-left: auto">
            <router-link tag="div" to="/homeClone" v-if="vueAppTypeName === ''">
              随便逛逛
            </router-link>
            <!-- <router-link
              tag="div"
              :to="{ path: '/contact/join', query: { attentionStoreId: storeId } }"
              v-if="vueAppTypeName !== ''"
            >
              加入族谱
            </router-link> -->
            <router-link tag="div" to="/zudian" v-if="vueAppTypeName !== ''">区域望族</router-link>
          </div>
        </div>
        <span class="introduce-span">{{ storeArr.introduce }}</span>
      </div>
      <!-- 三个按钮一行布局 -->
      <div class="action-buttons">

        <div class="action-btn" @click="handleNavigation" v-if="storeArr.latitude && storeArr.longitude">
          <span class="btn-text">导航</span>
        </div>
        <div class="action-btn" @click="goToProductList">
          <span class="btn-text">查看详情</span>
        </div>
        <share-button
          :path="'/home'"
          :query="getHomeShareQuery()"
          link-type="product"
          nfc-chip-id=""
          :title="storeArr.storeName"
          :content="storeArr.introduce || '欢迎来到我们的店铺'"
          :logo="storeArr.logo"
          class="action-btn"
        >
          <template slot="trigger">
            <span class="btn-text">分享</span>
          </template>
        </share-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { setStoreIdFromRouteOrLocalStorage } from '../../utils/store';

  import { mapActions } from 'vuex';
  import api from '../../utils/api';
  import { aGet } from '../../utils/request';
  import indexedDB from '../../indexedDB';
  import Nonet from '../nonet/nonet.vue';
  import storeUserApi from '@/api/v3/storeUser';
  import ShareButton from '@/components/ShareButton';
  export default {
    name: 'home',
    components: {
      Nonet,
      Notice: () => import('../../components/notice/Notice'),
      BoothTitle: () => import('../../components/boothTitle/BoothTitle'),
      draggableButton: () => import('../../components/draggable-button/index.vue'),
      ShareButton,
    },
    data() {
      return {
        vueAppTypeName: process.env.VUE_APP_TYPE_NAME || '',
        btnIsClick: false,
        isDragging: false,
        storeArr: {},
        videoFiles: [],
        typet: true,
        permissionsList: [],
        powerStatus: undefined,
        videoLoaded: false,
        videoInstance: null,

        wifi: 1,
        mydbname: 'tts',
        myversion: 1,
        msg: '8888',

        shelfProductCount: 0,
        shelfCount: 0,

        storeId: 0,
        swiperWrapperStyle: {},
        isFullScreen: false,
      };
    },
    computed: {
      // userId 改为 computed，实时从 localStorage 读取，确保账号切换后能获取最新值
      userId() {
        return parseInt(localStorage.getItem('userId')) || 0;
      },
      showSlideText() {
        if (this.vueAppTypeName === 'ZUDIAN') {
          return '上滑进入族典';
        }
        return '上滑进入列表';
      },

      //公告
      noticeList() {
        return [{ content: this.storeArr.introduce }];
      },
    },
    async created() {
      this.storeId = setStoreIdFromRouteOrLocalStorage(this.$route);
      console.log(`/pages/home/Booth ------- storeId: ${this.storeId}`);
      this.storeUsers = await storeUserApi.getMyStores();

      let queryKeyCount = Object.keys(this.$route.query).length;

      if (navigator.onLine) {
        this.wifi = 1;
        //当页面没有携带任何查询参数时，this.$route.query 会是一个 空对象 ({})。

        if (window.plus) {
          this.getLocationOnReady();
        } else {
          document.addEventListener('plusready', this.getLocationOnReady, false);
        }

        console.log('----------getHomePageStore');
        await this.getHomePageStore();
        // 原本逻辑,queryKeyCount > 0 this.getHomePageStore()   else this.getStoreMessage()
        // 在 this.storeId 从lockStoreId获取后,就都使用 getHomePageStore 页面
        //console.log("----------getStoreMessage")
        //this.getStoreMessage()
      } else {
        console.log('222');
        this.wifi = 2;
        this.upCorer();

        this.getAllStorePermissionsList2();

        if (window.plus) {
          this.getLocationOnReady();
        } else {
          document.addEventListener('plusready', this.getLocationOnReady, false);
        }
        if (queryKeyCount > 0) {
          this.getstore();
        } else {
          // this.get
          this.getStoreMessage2();
        }
      }
    },
    methods: {
      splitCsv(value) {
        if (typeof value !== 'string') {
          return [];
        }
        return value
          .split(',')
          .map(item => item.trim())
          .filter(Boolean);
      },
      // 分享用query，容错：优先 storeArr.storeId，其次 this.storeId，再次 localStorage.storeId
      getHomeShareQuery() {
        const sid = this.storeArr && this.storeArr.storeId
          ? this.storeArr.storeId
          : (this.storeId || localStorage.getItem('storeId') || localStorage.getItem('currentStoreId'));
        const uid = this.userId || localStorage.getItem('userId') || localStorage.getItem('id');
        return `storeId=${sid || ''}&userId=${uid || ''}`;
      },
      ...mapActions(['setStoreId']),

      // 导航功能
      handleNavigation() {
        if (this.storeArr.latitude && this.storeArr.longitude) {
          const url = `http://api.map.baidu.com/marker?location=${this.storeArr.latitude},${this.storeArr.longitude}&title=${this.storeArr.address || this.storeArr.storeName}&content=${this.storeArr.address || this.storeArr.storeName}&coordtype=wgs84ll&output=html&src=webapp.baidu.openAPIdemo`;
          // H5环境
          if (typeof window !== 'undefined' && window.open) {
            window.open(url);
          }
          // APP环境
          else if (typeof plus !== 'undefined' && plus.runtime) {
            plus.runtime.openURL(url);
          }
          // 其他环境的兜底处理
          else {
            this.$toast('当前环境不支持导航功能');
          }
        } else {
          this.$toast('店铺地址信息不完整');
        }
      },

      updateBoothHeight() {
        this.$nextTick(() => {
          // 获取窗口高度
          const windowHeight = window.innerHeight;
          // 获取底部 footer 高度
          const footer = document.querySelector('.tFooter');
          const footerHeight = footer ? footer.offsetHeight : 0;

          const content = document.querySelector('.content-container');
          const contentHeight = content ? content.offsetHeight : 0;

          // 计算 booth-container 的高度
          const boothContainerHeight = windowHeight - footerHeight;

          console.log(
            '窗口高度:',
            windowHeight,
            'Footer 高度:',
            footerHeight,
            'booth-container 高度:',
            boothContainerHeight
          );

          // 设置 booth-container 和 booth 的高度
          const boothContainer = document.querySelector('.booth-container');
          if (boothContainer) {
            boothContainer.style.height = `${boothContainerHeight}px`;
          }

          const booth = document.querySelector('.booth');
          if (booth) {
            let boothHeight = boothContainerHeight - contentHeight;
            booth.style.height = `${boothHeight}px`;

            console.log('boothHeight高度:', boothHeight);
          }
        });
      },

      updateSwiperWrapperHeight() {
        //return
        // //const containerHeight = document.querySelector('.booth-container').offsetHeight;
        //
        // const containerHeight = window.innerHeight; // 使用 window.innerHeight 避免 viewport 问题
        //
        // // 获取内容区域高度
        // const contentHeight = this.$refs.content-container ? this.$refs.content-container.offsetHeight : 240;
        // // 计算轮播区域高度
        // const swiperHeight = containerHeight - contentHeight
        //
        // console.log('高度计算:', {containerHeight, contentHeight, swiperHeight});
        //
        // // 设置swiper-wrapper高度
        // this.swiperWrapperStyle = {
        //   height: `${swiperHeight}px`
        // };
        //
        // // 更新视频容器高度
        // this.$nextTick(() => {
        //   const videoWrapper = document.querySelector('.video-wrapper');
        //   const video = this.$refs.videoPlayer;
        //   if (videoWrapper) {
        //     videoWrapper.style.height = `${swiperHeight}px`;
        //   }
        //   if (video) {
        //     video.style.height = `${swiperHeight}px`;
        //   }
        //
        //   const mediaWrapper = document.querySelector('.media-wrapper');
        //   if (mediaWrapper) {
        //     mediaWrapper.style.height = `${swiperHeight}px`;
        //   }
        // });
      },
      handleVideoEnd() {
        console.log('视频播放完成');
        const videoPlayer = this.$refs.videoPlayer;
        if (videoPlayer) {
          // 暂停视频播放
          videoPlayer.pause();
          // 如果需要，设置当前时间为 0
          videoPlayer.currentTime = 0;
        }
      },
      onMouseDown() {
        console.log('mouse down');
        this.isDragging = true;
      },
      onMouseUp() {
        console.log('mouse up');
        setTimeout(() => {
          this.isDragging = false;
        }, 100); // 延时 100ms
      },
      onTouchStart() {
        console.log('touch start', this.isDragging, this.btnIsClick);
        this.isDragging = true;
      },
      onTouchEnd() {
        console.log('touch end', this.isDragging, this.btnIsClick);
        setTimeout(() => {
          this.isDragging = false;
          console.log('----------reset ', this.isDragging);
        }, 100); // 延时 100ms
      },
      setLotteryPosition() {
        const linkDiv = document.querySelector('.link');
        const backIcon = document.querySelector('.backIcon'); // 获取 .backIcon 元素

        console.log('-----', linkDiv, backIcon);
        if (linkDiv && backIcon) {
          // 获取 link 元素的位置信息
          const linkRect = linkDiv.getBoundingClientRect();

          // 设置 backIcon 的位置，使其漂浮在 link 左侧
          //backIcon.style.position = 'absolute'; // 确保 backIcon 是绝对定位
          backIcon.style.top = `${linkRect.top}px - 90`;
          backIcon.style.left = `${linkRect.left - 70}px`; // 调整 -10px 可以自定义偏移量
        }
      },
      handleClick() {
        console.log('handle click test', this.isDragging, this.btnIsClick);
        if (this.btnIsClick) {
          this.gotoLottery();
        }
      },
      gotoLottery() {
        console.log('gotoLottery');
        this.$router.push('/Lottery?storeId=' + this.storeId);
      },
      //更新产品表封面
      async upCorer() {
        var that = this;
        const res = await indexedDB.dbOperation('productsAll', 'getAll');
        res.forEach(async (v, i) => {
          const r = await indexedDB.dbOperation('productCover', 'get', v.id);

          if (r.imgFiles) {
            v.productCover = r.imgFiles;
          }

          indexedDB.update('productsAll', v);
        });
      },

      // 获取全部店铺权限
      async getAllStorePermissionsList2() {
        const res = await indexedDB.dbOperation('allStorePermissionsList', 'getAll');
        this.permissionsList = res;
      },

      //我的展台页面数据1
      async getStoreMessage2() {
        var that = this;
        let personId = localStorage.getItem('id');
        console.log('personId', personId);
        if (personId) {
          if (!navigator.onLine) {
            const data = await indexedDB.dbOperation('storeArr', 'get', parseInt(personId));
            console.log('getStoreMessage2()', data);

            let obj = data;
            if (obj == undefined) {
              return;
            }
            if (Object.entries(obj).length !== 0) {
              that.storeArr = obj;
              localStorage.setItem('storeId', that.storeArr.storeId);
            }
          } else {
            // let userId = parseInt(personId) //字符串转整数
            // that.getstore('store', userId, 'userId')
          }
        }
      },

      //读取store数据
      async getstore(st, dat, index) {
        console.log('aaaaaaaaa');
        var that = this;
        const conn = window.indexedDB.open(this.mydbname, this.myversion);
        conn.onsuccess = function (event) {
          var db = event.target.result;

          var request = db.transaction([st]).objectStore(st).index(index).get(dat);
          request.onsuccess = async function (event) {
            if (request.result) {
              var obj = request.result;

              let setObj = {
                backgroundImgs: that.splitCsv(obj.background),
                logo: obj.logo,
                honestyName: obj.honestyName,
                showroomUrl: obj.showroomUrl,
                introduce: obj.storeDetails,
                storeId: obj.id,
                storeIdentity: obj.storeIdentity,
                storeName: obj.name,
              };
              that.storeArr = setObj;
              console.log('--------obj', obj);
              that.videoFiles = that.splitCsv(obj.video);

              localStorage.setItem('storeId', that.storeArr.storeId);
              //  that.msg=that.storeArr;
            }
          };
        };
      },

      // async add () {

      //     const data = {
      //         name: 'name',
      //         age: 'age',
      //         email: 'email@11.11'
      //     }
      //     const res = await indexedDB.dbOperation('add');
      //     console.log(res);
      //     },

      //     async read () {
      //     const res = await indexedDB.dbOperation('get', 1)
      //     console.log(res)
      //     },

      // 查询用户是否购买功能权限
      async getUserWhetherPurchaseStorePermissions(id) {
        // return new Promise(reslove => {
        let parma = {
          storeId: localStorage.getItem('storeId'),
          powersId: id,
        };
        //  console.log(parma);
        // let res = aGet(api.getUserWhetherPurchaseStorePermissions,parma)
        await aGet(api.getUserWhetherPurchaseStorePermissions, parma).then(res => {
          this.powerStatus = res.data;
          //  console.log("222", this.powerStatus);
        });

        // console.log('查询用户是否购买功能权限',res);

        // reslove(res.data)
        // })
      },
      // 获取全部店铺权限
      getAllStorePermissionsList() {
        aGet(api.getAllStorePermissionsList).then(res => {
          // console.log("全部店铺权限", res);
          this.permissionsList = res.data.data;
          // console.log("xxxx", this.permissionsList);
        });
      },

      // 展厅
      async jumpExhibition() {
        let obj = this.permissionsList.filter(item => item.powerName == '展厅');
        let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id);

        // setTimeout( () => {
        if (this.powerStatus != undefined && this.powerStatus == false) {
          this.$toast('您暂无此权限,请先购买权限配置！');
          this.$router.push({
            path: '/buyservice',
          });
        } else if (this.powerStatus != undefined && this.powerStatus == true) {
          this.$router.push({
            path: '/Exhibition',
          });
        }
        // },300)
      },
      ...mapActions(['setBoothStoreDetail']),
      // 查看商品按钮点击事件
      goToProductList() {
        console.log('点击查看商品按钮');
        let currentStoreId = localStorage.getItem('currentStoreId');
        if ((currentStoreId == null) || (currentStoreId == undefined) || (currentStoreId == '')) {
          localStorage.setItem('currentStoreId', this.storeArr.storeId);
        }
        this.$router.push({
          path: '/product/list',
          query: { storeId: this.storeArr.storeId },
        });
      },

      // 分享按钮点击事件 (此方法已不再需要，因为ShareButton组件会处理点击)
      // handleShare() {
      //   console.log('点击分享按钮，这里将由ShareButton组件处理');
      // },

      // 分享兜底方案 (此方法已不再需要)
      // fallbackShare(shareData) {
      //   const shareUrl = `${window.location.origin}/#${shareData.path}?${shareData.query}`;
      //   // 复制到剪贴板
      //   if (navigator.clipboard) {
      //     navigator.clipboard.writeText(shareUrl).then(() => {
      //       this.$toast('链接已复制到剪贴板');
      //     }).catch(() => {
      //       this.$toast('分享失败');
      //     });
      //   } else {
      //     // 兜底方案：创建临时输入框
      //     const textArea = document.createElement('textarea');
      //     textArea.value = shareUrl;
      //     document.body.appendChild(textArea);
      //     textArea.select();
      //     try {
      //       document.execCommand('copy');
      //       this.$toast('链接已复制到剪贴板');
      //     } catch (err) {
      //       this.$toast('分享失败');
      //     }
      //     document.body.removeChild(textArea);
      //   }
      // },

      //上滑进入商品列表（保留原有逻辑作为兜底）
      topSlide() {
        if (!this.isDragging) {
          this.goToProductList();
        }
      },
      //店铺首页数据
      async getHomePageStore() {
        let { data } = await this.$http.aPost(this.$api.getHomePageStore, { storeId: this.storeId });
        let obj = data.data.store;

        this.shelfProductCount = (data && data.data && data.data.shelfProductCount) || 0;
        this.shelfCount = (data && data.data && data.data.shelfCount) || 0;

        console.log('----------getHomePageStore', obj);
        let setObj = {
          backgroundImgs: this.splitCsv(obj.background),
          logo: obj.logo,
          honestyName: obj.honestyName,
          showroomUrl: obj.showroomUrl,
          introduce: obj.storeDetails,
          storeId: obj.id,
          storeIdentity: obj.storeIdentity,
          storeName: obj.name,
          isHeadStore: obj.isHeadStore,
          latitude: parseFloat(obj.latitude || 0),  // 转换为数字类型，提供默认值以防null或undefined
          longitude: parseFloat(obj.longitude || 0), // 转换为数字类型，提供默认值以防null或undefined
        };
        this.storeId = obj.id;
        this.videoFiles = this.splitCsv(obj.video);
        this.storeArr = setObj;
        console.log(this.storeArr);

        //this.storeArr = data.storeHomePage

        // console.log('店铺首页数据:',data);
      },
      //我的展台页面数据
      async getStoreMessage() {
        console.log('-----------getStoreMessage');
        if (this.userId > 0) {
          let { data } = await this.$http.aPost(this.$api.getStoreMessage, { id: this.userId });
          let obj = data.data.store;
          this.shelfProductCount = (data && data.data && data.data.shelfProductCount) || 0;
          this.shelfCount = (data && data.data && data.data.shelfCount) || 0;

          console.log(JSON.stringify(data.data.store));
          if (Object.entries(obj).length !== 0) {
            let setObj = {
              backgroundImgs: this.splitCsv(obj.background),
              logo: obj.logo,
              honestyName: obj.honestyName,
              showroomUrl: obj.showroomUrl,
              introduce: obj.storeDetails,
              storeId: obj.id,
              storeIdentity: obj.storeIdentity,
              storeName: obj.name,
            };
            this.storeId = obj.id;
            this.storeArr = setObj;
            this.videoFiles = this.splitCsv(obj.video);
            localStorage.setItem('type', this.storeArr.storeIdentity);
          }
          localStorage.setItem('storeId', this.storeArr.storeId);
        }
      },

      // get(){
      //   var that=this;
      //   const conn = window.indexedDB.open(that.mydbname,that.myversion);

      //             conn.onsuccess = function (event) {
      //                 const db = event.target.result;
      //                 var transaction = db.transaction(['store'], 'readonly');
      //                 var store = transaction.objectStore('store');
      //                 var index = store.index('userId');
      //                 let userId = parseInt(personId);//字符串转整数
      //                 var request = index.get(userId);
      //                 request.onsuccess = function (e) {
      //                   const result = e.target.result;
      //                   return result;
      //                 }
      //             }
      //           },

      async imgUrlToBase64(imageUrl) {
        var img64;
        var that = this;

        var promise = new Promise(res => {
          let image = new Image(); // 一定要设置为let，不然图片不显示
          image.setAttribute('crossOrigin', 'anonymous'); // 解决跨域问题
          //image.src = imageUrl +"&v=" + Math.random() // 如果是本地图片替换为 image.src = imageUrl
          image.src = imageUrl; // 如果是本地图片替换为 image.src = imageUrl
          image.onload = () => {
            var canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            var context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            var quality = 0.8;
            var dataURL = canvas.toDataURL('image/jpeg', quality); // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
            img64 = dataURL;
            res(img64);
          };
        });

        await promise;

        return img64;
      },

      getLocationOnReady() {
        if(plus.runtime.isAgreePrivacy()) {
          plus.geolocation.getCurrentPosition(
            p => {
              this.latitude = p.coords.latitude;
              this.longitude = p.coords.longitude;
              let location = {
                latitude: this.latitude,
                longitude: this.longitude,
              };
              //  console.log(location)
              sessionStorage.setItem('location', JSON.stringify(location));
              sessionStorage.setItem('latitude', this.latitude);
              sessionStorage.setItem('longitude', this.longitude);
              console.log('location2', JSON.stringify(location));
              // alert('Geolocation\nLatitude:' + p.coords.latitude + '\nLongitude:' + p.coords.longitude + '\nAltitude:' + p.coords.altitude);
            },
            function (e) {
              console.log('定位错误2', e.message);
              alert('请打开定位');
            }
          );
        } else {
          this.latitude = -1;
          this.longitude = -1;
          console.log("======未同意隐私协议不获取定位")
        }
      },
      // 添加视频加载处理方法
      handleVideoLoaded() {
        const video = this.$refs.videoPlayer;
        if (video) {
          this.updateSwiperWrapperHeight(); // 视频加载完成后重新计算高度
          video.play().catch(err => console.log('视频自动播放失败:', err));
        }
      },

      // 添加视频错误处理方法
      handleVideoError(e) {
        console.log('视频加载错误:', e);
      },

      // 初始化视频
      initVideo() {
        this.$nextTick(() => {
          this.videoInstance = this.$refs.videoPlayer;
          if (this.videoInstance) {
            this.videoInstance.load();
            //this.updateSwiperWrapperHeight(); // 重新计算高度
            this.updateBoothHeight();
            this.videoInstance.play().catch(err => console.log('视频播放失败:', err));
          }
        });
      },

      handleFullScreen() {
        const video = this.$refs.videoPlayer;
        if (!video) return;

        try {
          if (!this.isFullScreen) {
            if (video.requestFullscreen) {
              video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) {
              video.webkitRequestFullscreen();
            } else if (video.mozRequestFullScreen) {
              video.mozRequestFullScreen();
            } else if (video.msRequestFullscreen) {
              video.msRequestFullscreen();
            }
          } else {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          }
          this.isFullScreen = !this.isFullScreen;
        } catch (error) {
          console.log('全屏切换失败:', error);
        }
      },
    },
    mounted() {
      this.setLotteryPosition();
      this.updateBoothHeight();
      this.updateSwiperWrapperHeight();
      this.initVideo();
      window.addEventListener('resize', this.updateSwiperWrapperHeight);
    },
    activated() {
      this.updateBoothHeight();
      // 组件被激活时重新获取数据和初始化视频
      if (navigator.onLine) {
        this.getHomePageStore().then(() => {
          this.$nextTick(() => {
            this.updateSwiperWrapperHeight(); // 重新计算高度
            const video = this.$refs.videoPlayer;
            if (video) {
              video.load();
              video.play().catch(err => console.log('视频播放失败:', err));
            }
          });
        });
      }
    },
    deactivated() {
      // 组件被停用时停止视频播放并清理资源
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    beforeDestroy() {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.removeEventListener('ended', this.handleVideoEnd);
        videoPlayer.pause();
        videoPlayer.src = '';
        videoPlayer.load();
      }
      window.removeEventListener('resize', this.updateSwiperWrapperHeight);
      this.videoInstance = null;
    },
    //自定义上滑指令
    directives: {
      //滑动指令
      touch: {
        bind: function (el, binding) {
          var touchType = binding.arg; //传入的模式 press swipeRight swipeLeft swipeTop swipeDowm Tap
          var timeOutEvent = 0;
          var direction = '';
          //滑动处理
          var startX, startY;

          //返回角度
          function GetSlideAngle(dx, dy) {
            return (Math.atan2(dy, dx) * 180) / Math.PI;
          }

          //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
          function GetSlideDirection(startX, startY, endX, endY) {
            var dy = startY - endY;
            var dx = endX - startX;
            var result = 0;

            //如果滑动距离太短
            if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
              return result;
            }

            var angle = GetSlideAngle(dx, dy);
            if (angle >= -45 && angle < 45) {
              result = 'swiperight';
            } else if (angle >= 45 && angle < 135) {
              result = 'swipeup';
            } else if (angle >= -135 && angle < -45) {
              result = 'swipedown';
            } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
              result = 'swipeleft';
            }
            return result;
          }

          el.addEventListener(
            'touchstart',
            function (ev) {
              startX = ev.touches[0].pageX;
              startY = ev.touches[0].pageY;

              //判断长按
              timeOutEvent = setTimeout(() => {
                timeOutEvent = 0;
                if (touchType === 'press') {
                  binding.value();
                }
              }, 500);
            },
            false
          );

          el.addEventListener('touchmove', function () {
            clearTimeout(timeOutEvent);
            timeOutEvent = 0;
          });

          el.addEventListener(
            'touchend',
            function (ev) {
              var endX, endY;
              endX = ev.changedTouches[0].pageX;
              endY = ev.changedTouches[0].pageY;
              direction = GetSlideDirection(startX, startY, endX, endY);

              clearTimeout(timeOutEvent);

              switch (direction) {
                case 0:
                  break;
                case 'swipeup':
                  if (touchType === 'swipeup') {
                    binding.value();
                  }
                  break;
                case 'swipedown':
                  if (touchType === 'swipedown') {
                    binding.value();
                  }
                  break;
                case 'swipeleft':
                  if (touchType === 'swipeleft') {
                    binding.value();
                  }
                  break;
                case 'swiperight':
                  if (touchType === 'swiperight') {
                    binding.value();
                  }
                  break;
                default:
              }
            },
            false
          );
        },
      },
    },
  };
</script>
<style scoped lang="scss">
  @import '../../assets/mixin';

  // 通用变量
  $primary-color: #50cc73;
  $secondary-color: #2fb555;
  $text-color: #333;
  $light-text-color: #666;
  $border-radius: 20px;
  // 容器布局
  .booth-container {
    width: 100%;
    height: 100vh;
    position: relative;
  }

  .booth {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .swiper-wrapper {
    width: 100%;
    flex: 1;
    min-height: 0;
    position: relative;

    .custom-swipe {
      height: 100%;
    }

    //.video-swipe-item {
    //  width: 100%;
    //  height: 100%;
    //  position: relative;
    //}

    //.video-wrapper {
    //  width: 100%;
    //  height: 100%;
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    //  right: 0;
    //  bottom: 0;
    //  background: #000;
    //  display: flex;
    //  justify-content: center;
    //  align-items: center;
    //}

    .video-player {
      width: 100%;
      height: 100%;
      object-fit: fill !important;
    }

    .media-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
    }

    .booth-bannerImg {
      width: 100%;
      height: 100%;
      object-fit: fill !important;
    }
  }

  .content-container {
    width: 100%;
    height: 240px;
    position: fixed;
    bottom: 100px;
    left: 0;
    background-color: #fff;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    padding: 26px 20px 0;

    .info {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 26px;

        .left {
          .booth-title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              img {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                object-fit: cover;
              }

              span {
                display: inline-block;
                line-height: 56px;
                margin-left: 16px;
                font-size: 32px;
                color: #000000;
                text-stroke: 1 rgba(0, 0, 0, 0);
                font-weight: bold;
              }

              .navigation-btn {
                display: flex;
                align-items: center;
                margin-left: 16px;
                padding: 8px 12px;
                background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
                border-radius: 20px;
                cursor: pointer;
                transition: all 0.3s ease;

                &:active {
                  background: linear-gradient(330deg, #1fa045 0%, #3eaa5f 100%);
                }

                .nav-icon {
                  width: 20px;
                  height: 20px;
                  margin-right: 6px;
                  position: relative;

                  &::before {
                    content: '';
                    position: absolute;
                    width: 12px;
                    height: 12px;
                    border: 2px solid #ffffff;
                    border-radius: 50%;
                    top: 2px;
                    left: 2px;
                  }

                  &::after {
                    content: '';
                    position: absolute;
                    width: 0;
                    height: 0;
                    border: 4px solid transparent;
                    border-top-color: #ffffff;
                    top: 14px;
                    left: 6px;
                  }
                }

                span {
                  font-size: 24px;
                  color: #ffffff;
                  line-height: 1;
                  margin-left: 0;
                  font-weight: normal;
                }
              }
            }

            ul {
              display: flex;
              align-items: center;
              margin-left: 20px;
              font-size: 28px;

              li {
                &:first-child {
                  text-stroke: 1 rgba(0, 0, 0, 0);
                  color: #666666;
                }

                &:last-child {
                  margin-left: 16px;
                  font-weight: bold;
                  color: #333333;
                }
              }
            }
          }
        }

        .link {
          width: auto;
          height: 96px;
          padding: 0 17px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            width: 128px;
            height: 48px;
            border: 1px solid rgba(0, 0, 0, 0);
            background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
            border-radius: 40px;
            outline: none;
            text-align: center;
            line-height: 48px;
            font-size: 24px;
            color: #ffffff;
          }

          span {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 26px;
            color: #666666;

            &:before {
              content: '';
              width: 26px;
              height: 26px;
              display: inline-block;
              background: url('../../assets/img/home/go-up.png') center bottom no-repeat;
              background-size: contain;
              margin-right: 16px;
              margin-bottom: -5px;
            }
          }
        }
      }
    }

    .action-buttons {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;
      gap: 10px;

      .action-btn {
        flex: 1; /* 确保等宽 */
        height: 40px;
        background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 4px 12px rgba(47, 181, 85, 0.3);
        box-sizing: border-box; /* 确保盒模型一致 */

        &:active {
          background: linear-gradient(330deg, #1fa045 0%, #3eaa5f 100%);
          transform: translateY(2px);
          box-shadow: 0 2px 8px rgba(47, 181, 85, 0.4);
        }

        .btn-text {
          font-size: 24px;
          color: #ffffff;
          font-weight: bold;
          text-align: center;
        }

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(47, 181, 85, 0.4);
        }
      }
    }
  }

  .video-wrapper {
    .custom-video-controls {
      position: absolute;
      right: 10px;
      bottom: 60px;
      z-index: 2;

      .fullscreen-button {
        width: 36px;
        height: 36px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:active {
          background: rgba(0, 0, 0, 0.7);
        }

        .fullscreen-icon {
          width: 20px;
          height: 20px;
          background: url("data:image/svg+xml,%3Csvg t='1710400411839' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4231' width='32' height='32'%3E%3Cpath d='M160 96h186.666667v72.533333H160v166.4H87.466667V96H160z m689.066667 72.533333H662.4V96h274.133333v238.933333h-72.533333V168.533333zM160 855.466667v-166.4H87.466667V928H362.666667v-72.533333H160z m589.866667 0H662.4V928h274.133333v-238.933333h-72.533333v166.4z' fill='%23ffffff' p-id='4232'%3E%3C/path%3E%3C/svg%3E")
          center/contain no-repeat;
        }
      }
    }
  }

  .introduce-span {
    display: block;
    width: 95%;
    margin: 10px auto;
    text-align: center;
    font-size: 24px;
    color: #333;
    padding: 5px;
    //border: 1px solid #e7bb8f;
    border-radius: 10px;
    //background-color: #fff8f0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue